import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { HELP_SECTION_UPLOAD_CODES, HELP_TOPIC_APPLY_CODES_UPLOAD_CODES } from '@app/constants';

const UploadCodesSection = ({ activeTopic, scrollToTopic }) => {
  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_UPLOAD_CODES} className="help-section">
      <div id={HELP_TOPIC_APPLY_CODES_UPLOAD_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-upload-codes" tagName="h2" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p3" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p4" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p5" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-upload-codes-p6" tagName="p" />
        </div>
      </div>
    </div>
  );
};

UploadCodesSection.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  activeTopic: PropTypes.string,
};

export default UploadCodesSection;
